import { render, staticRenderFns } from "./ModalRemanejarPAF.vue?vue&type=template&id=b73fdbc8"
import script from "./ModalRemanejarPAF.vue?vue&type=script&lang=js"
export * from "./ModalRemanejarPAF.vue?vue&type=script&lang=js"
import style0 from "./ModalRemanejarPAF.vue?vue&type=style&index=0&id=b73fdbc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports